import { Injectable } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

/**
 * ngx-translate's own default behavior for a key with no entry in the active locale file (and no
 * fallback either) is to silently render the raw dotted key string - which reads enough like a
 * plausible technical label (e.g. "admin.approvalRouting.actionNames.WorkOrder.Dispatch.action") that
 * it can pass an otherwise-careful screenshot review undetected (found live, twice, in this increment).
 * Wrapping it instead makes a miss impossible to mistake for real content in any manual QA pass -
 * this doesn't prevent shipping a missing key (see the i18n audit's Tier 2 for that), it just makes
 * one loud instead of silent.
 */
@Injectable()
export class LoudMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    return `⚠MISSING:${params.key}⚠`;
  }
}
